import React from 'react';

const Blockquote = ({ children }) => (
  <blockquote className="pl-6 md:pl-12 my-6 md:my-12 border-l-2 border-cornflower italic">
    {children}
  </blockquote>
);

export default Blockquote;
